import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CheckInCartItemsDialogData {
  itemCount: number;
}

@Component({
  selector: 'app-check-in-cart-items-dialog',
  templateUrl: './check-in-cart-items-dialog.component.html',
  styleUrls: ['./check-in-cart-items-dialog.component.scss'],
})
export class CheckInCartItemsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CheckInCartItemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CheckInCartItemsDialogData,
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
